import React from 'react';
import './Footer.scss';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { useHeaderMenu } from '../../contexts/login.context';
import { useLocalization } from '../../contexts/LocalizationContext';
// import { Footer as GlobalFooter } from "@ecl/react";
//import headerfooterData from "../../constants/headerFooterData.json";
function Footer() {
    const year = new Date().getFullYear();
    const { t } = useTranslation();
    const { isDownload } = useHeaderMenu();
    const { locale } = useLocalization();
    // const [apiData, setApiData] = useState<any>(null);
    // const locale = window.location.pathname.split('/')[1];
    // const CountryTitle: any = {
    //     "en-us": "USA - United States",
    //     "en-gb": "United Kingdom",
    // };
    // useEffect(() => {
    //     const fetchApiData = async () => {
    //         try {
    //             const response = await headerfooterData;
    //             const data = await response;
    //             setApiData(data);
    //         } catch (error) {
    //             console.error("Error fetching data:", error);
    //         }
    //     };

    //     fetchApiData();
    // }, []);
    return (
        <div className="footer">
            <Container>
                <Row xs={'auto'} md={'auto'}>
                    <Col md={12}>
                        <p className="dr_legalPolicyLinks">
                            <a className="dr_privacyPolicy" href={locale === 'en-hk' ? 'https://www.nvidia.cn/about-nvidia/privacy-policy/' : (locale === 'en-me' || locale === 'en-af' ? 'https://www.nvidia.com/en-eu/about-nvidia/privacy-policy/' : locale === 'en-ph' ? 'https://www.nvidia.com/en-us/about-nvidia/privacy-policy/' : `https://www.nvidia.com/${locale === 'en-ca' || locale === 'vi-vn' ? 'en-us' : locale}/about-nvidia/privacy-policy/`)} target="_blank" rel="noreferrer">{t('PRIVACY_POLICY')}</a>&nbsp;&nbsp;&nbsp;
                            <a className="dr_termsAndConditions" href={locale === 'en-hk' ? 'https://www.nvidia.cn/about-nvidia/privacy-center/' : (locale === 'en-me' || locale === 'en-af' ? 'https://www.nvidia.com/en-eu/about-nvidia/privacy-center/' : locale === 'en-ph' ? 'https://www.nvidia.com/en-us/about-nvidia/privacy-center/' : `https://www.nvidia.com/${locale === 'en-ca' || locale === 'vi-vn' ? 'en-us' : locale}/privacy-center/`)} target="_blank" rel="noreferrer">{t('MANAGE_PRIVACY')}</a>&nbsp;&nbsp;&nbsp;
                            {locale === 'en-hk' ? (
                                <a className="dr_ccpa" href="https://www.nvidia.cn/privacy/" target="_blank" rel="noreferrer">{t('DATA_NOTICE')}</a>
                            ) : locale === 'en-me' || locale === 'en-af' ? (
                                <a className="dr_ccpa" href="https://www.nvidia.com/en-eu/privacy/" target="_blank" rel="noreferrer">{t('DATA_NOTICE')}</a>
                            ) : locale === 'en-ph' ? (
                                <a className="dr_ccpa" href="https://www.nvidia.com/en-ph/privacy/" target="_blank" rel="noreferrer">{t('DATA_NOTICE')}</a>
                            ) : (
                                locale === 'en-ca' ? (
                                    <a className="dr_ccpa" href={`https://www.nvidia.com/${locale === 'en-ca' ? 'en-us' : locale}/preferences/email-preferences/`} target="_blank" rel="noreferrer">{t('DATA_NOTICE')}</a>
                                ) : (
                                    <a className="dr_ccpa" href={`https://www.nvidia.com/${locale}/privacy/`} target="_blank" rel="noreferrer">{t('DATA_NOTICE')}</a>
                                )
                            )}&nbsp;&nbsp;&nbsp;
                            {!isDownload ?
                                <>
                                    <a className="dr_termsAndConditions" href={locale === 'en-hk' ? 'https://www.nvidia.cn/about-nvidia/terms-of-service/' : (locale === 'en-me' || locale === 'en-af' ? 'https://www.nvidia.com/en-eu/about-nvidia/terms-of-service/' : locale === 'en-ph' ? 'https://www.nvidia.com/en-us/about-nvidia/terms-of-service/' : locale === 'nb-no' ? 'https://www.nvidia.com/en-eu/about-nvidia/terms-of-service/' : `https://www.nvidia.com/${(locale === 'es-mx' ? 'es-la' : (locale === 'en-ca' ? 'en-us' : locale))}/about-nvidia/terms-of-service/`)} target="_blank" rel="noreferrer">{t('TERMS_OS')}</a>
                                    &nbsp;&nbsp;&nbsp;
                                    <a className="dr_termsAndConditions" href={`https://marketplace.nvidia.com/${locale === 'en-ca' || locale === 'es-mx' ? 'en-us' : locale}/terms-of-sale/`} target="_blank" rel="noreferrer">{t('TERMS_OF_SALE')}</a>
                                </>
                                :
                                locale === 'en-ca' || locale === 'en-us' || locale === 'en-sg' || locale === 'en-au' ?
                                    <a className="dr_termsAndConditions" href='https://www.nvidia.com/en-us/agreements/enterprise-services/nvidia-training-services-terms-and-conditions/' target="_blank" rel="noreferrer">{t('TERMS_OS_TRAINING')}</a>
                                    :
                                    locale === 'es-mx' ?
                                        <a className="dr_termsAndConditions" href={`https://www.nvidia.com/es-la/about-nvidia/terms-of-service/`} target="_blank" rel="noreferrer">{t('TERMS_OS')}</a>
                                        :
                                        <a className="dr_termsAndConditions" href={locale === 'en-hk' ? 'https://www.nvidia.cn/about-nvidia/terms-of-service/' : (locale === 'en-me' || locale === 'en-af' ? 'https://www.nvidia.com/en-eu/about-nvidia/terms-of-service/' : locale === 'nb-no' ? 'https://www.nvidia.com/en-eu/about-nvidia/terms-of-service/' : `https://www.nvidia.com/${locale === 'en-ca' || locale === 'vi-vn' || locale==='en-ph' ? 'en-us' : locale}/about-nvidia/terms-of-service/`)} target="_blank" rel="noreferrer">{t('TERMS_OS')}</a>
                            }
                        </p>
                        <span id="copyright">{t('nvidiaSI_GIFT_FOOTER_CONTENT1')}{year} {t('nvidiaSI_NONGFN_FOOTER_CONTENT2')}</span>
                    </Col>
                </Row>
            </Container>


            {/* <GlobalFooter
                footerTableItems={apiData?.NVIDIAglobalFooter[0]?.footerTableItems}
                globalFooterLegalLinks={
                    apiData?.NVIDIAglobalFooter[0]?.globalFooterLegalLinks
                }
                countrySelectorRedirectUrl="https://www.nvidia.com/location-selector/"
                countries={[]}
                showCountrySelector={true}
                countryTitle={CountryTitle[locale?.toString()]}
            /> */}
        </div>
    )
}
export default Footer;